import ScalarIconWebhooksLogo_vue_vue_type_script_setup_true_lang_default from "./ScalarIconWebhooksLogo.vue.script.js";
//#region src/components/ScalarIconWebhooksLogo.vue
var ScalarIconWebhooksLogo_default = ScalarIconWebhooksLogo_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconWebhooksLogo_default as default };

//# sourceMappingURL=ScalarIconWebhooksLogo.js.map